export enum Properties {
  sizing = 'sizing',
  height = 'height',
  width = 'width',
  spacing = 'spacing',
  verticalPadding = 'verticalPadding',
  horizontalPadding = 'horizontalPadding',
  paddingTop = 'paddingTop',
  paddingRight = 'paddingRight',
  paddingBottom = 'paddingBottom',
  paddingLeft = 'paddingLeft',
  itemSpacing = 'itemSpacing',
  fill = 'fill',
  border = 'border',
  borderRadius = 'borderRadius',
  borderRadiusTopLeft = 'borderRadiusTopLeft',
  borderRadiusTopRight = 'borderRadiusTopRight',
  borderRadiusBottomRight = 'borderRadiusBottomRight',
  borderRadiusBottomLeft = 'borderRadiusBottomLeft',
  borderWidth = 'borderWidth',
  borderWidthTop = 'borderWidthTop',
  borderWidthRight = 'borderWidthRight',
  borderWidthBottom = 'borderWidthBottom',
  borderWidthLeft = 'borderWidthLeft',
  boxShadow = 'boxShadow',
  opacity = 'opacity',
  fontFamilies = 'fontFamilies',
  fontWeights = 'fontWeights',
  fontSizes = 'fontSizes',
  lineHeights = 'lineHeights',
  typography = 'typography',
  composition = 'composition',
  letterSpacing = 'letterSpacing',
  paragraphSpacing = 'paragraphSpacing',
  textCase = 'textCase',
  textDecoration = 'textDecoration',
  asset = 'asset',
  tokenValue = 'tokenValue',
  value = 'value',
  tokenName = 'tokenName',
  description = 'description',
}
